<template>
  <div class="conver-conf">
    <div class="card-header">
      <span class="title-text">其他配置</span>
    </div>
    <div class="content-wrap">
      <ul class="form-wrap">
        <el-form :model="formData" :rules="rules" ref="converformRef">
          <li class="form-item">
            <span class="form-label require" style="padding-top: 10px"
              >下载链接：</span
            >
            <div class="form-value">
              <el-form-item prop="download_url">
                <el-input
                  style="width: 264px"
                  placeholder="选择应用自动填充"
                  v-model="formData.download_url"
                  :disabled="true"
                ></el-input>
              </el-form-item>
            </div>
          </li>
          <li class="form-item">
            <span class="form-label" style="padding-top: 10px"
              >应用商店下载：</span
            >
            <div class="form-value">
              <el-form-item>
                <el-radio-group v-model="formData.download_mode">
                  <el-radio label="DEFAULT">不开启</el-radio>
                  <el-radio label="APP_STORE_DELIVERY">开启</el-radio>
                </el-radio-group>
              </el-form-item>
            </div>
          </li>
          <li class="form-item">
            <span class="form-label" style="padding-top: 10px">检测链接：</span>
            <div class="form-value">
              <el-form-item>
                <el-radio-group v-model="formData.track_url_group_type">
                  <el-radio label="TRACK_URL_GROUP_ID">已有链接</el-radio>
                </el-radio-group>
              </el-form-item>
            </div>
          </li>
          <li class="form-item">
            <span class="form-label require" style="padding-top: 10px"
              >选择链接：</span
            >
            <div class="form-value">
              <el-form-item prop="track_url_group_id">
                <el-select
                  v-model="formData.track_url_group_id"
                  @change="changeLink"
                >
                  <el-option
                    v-for="item of linkOptions"
                    :key="item.track_url_group_id"
                    :label="item.track_url_group_name"
                    :value="item.track_url_group_id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <div class="link-wrap">
                <div class="link-header">链接信息</div>
                <div class="link-content">
                  展示：
                  <p class="link-area">{{ showUrl.truck_url }}</p>
                  有效触点：
                  <p class="link-area">{{ showUrl.action_track_url }}</p>
                  视频播放：
                  <p class="link-area">{{ showUrl.video_play_track_url }}</p>
                  视频播完：
                  <p class="link-area">
                    {{ showUrl.video_play_done_track_url }}
                  </p>
                  视频有效播放：
                  <p class="link-area">
                    {{ showUrl.video_play_effective_track_url }}
                  </p>
                </div>
              </div>
            </div>
          </li>
        </el-form>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { getTruckUrl } from "@/api/promotion.js";

export default {
  data() {
    return {
      formData: {
        download_url: "",
        download_mode: "DEFAULT",
        track_url_group_type: "TRACK_URL_GROUP_ID",
        track_url_group_id: null,
        asset_id: null,
      },
      rules: {
        download_url: [
          {
            required: true,
            message: "请选择应用",
            trigger: ["blur", "change"],
          },
        ],
        track_url_group_id: [
          {
            required: true,
            message: "请选择链接",
            trigger: ["blur", "change"],
          },
        ],
      },
      linkOptions: [],
      showUrl: {
        truck_url: "",
        action_track_url: "",
        video_play_track_url: "",
        video_play_done_track_url: "",
        video_play_effective_track_url: "",
      },
    };
  },
  methods: {
    checkData() {
      return new Promise((resolve, reject) => {
        this.$refs.converformRef.validate((valid) => {
          if (valid) {
            this.saveInStore();
            resolve();
          } else {
            reject();
          }
        });
      });
    },
    saveInStore() {
      this.formData.asset_id = this.checkedApp.asset_id;
      this.$store.commit(
        "set_eventInfo",
        JSON.parse(JSON.stringify(this.formData))
      );
    },
    changeLink(id) {
      let curUrlObj = this.linkOptions.find(
        (item) => item.track_url_group_id === id
      );
      if (curUrlObj) {
        this.showUrl.truck_url = curUrlObj.truck_url;
        this.showUrl.action_track_url = curUrlObj.action_track_url;
        this.showUrl.video_play_track_url = curUrlObj.video_play_track_url;
        this.showUrl.video_play_done_track_url =
          curUrlObj.video_play_done_track_url;
        this.showUrl.video_play_effective_track_url =
          curUrlObj.video_play_effective_track_url;
      }
    },
    searchLinkList(cb) {
      //查询选择链接数据
      getTruckUrl({
        advertiserId: this.adCount.map((item) => item.advertiserId).join(),
        assetId: this.checkedApp.asset_id,
        downloadUrl: this.checkedApp.download_url,
      }).then((res) => {
        if (res.code === "0000") {
          this.linkOptions = res.track_url_groups;
          if (cb) {
            cb.call(this);
          }
        }
      });
    },
  },
  computed: {
    ...mapState({
      eventInfo: (state) => state.Promotion.draft_adset.eventInfo,
      checkedApp: (state) => state.Promotion.checkedApp,
      adCount: (state) => state.Promotion.adCount,
    }),
  },
  watch: {
    eventInfo(value) {
      if (value) {
        this.formData.download_url = value.download_url;
        this.formData.download_mode = value.download_mode;
        this.formData.track_url_group_type = value.track_url_group_type;
        this.formData.track_url_group_id = value.track_url_group_id;
        if (this.linkOptions.length > 0) {
          this.changeLink(value.track_url_group_id);
        } else {
          setTimeout(() => {
            this.searchLinkList(() => {
              this.changeLink(value.track_url_group_id);
            });
          }, 500);
        }
      }
    },
    checkedApp(value) {
      if (value && value.download_url) {
        this.formData.download_url = value.download_url;
      }
      if (value && value.asset_id) {
        this.searchLinkList();
      }
    },
  },
};
</script>

<style lang="less" scoped>
.conver-conf {
  padding: 24px;
  margin-top: 16px;
  border-radius: 4px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
  .card-header {
    display: flex;
    justify-content: space-between;
    .title-text {
      color: rgba(0, 0, 0, 1);
      font-size: 16px;
      font-weight: bold;
    }
  }

  .content-wrap {
    padding-top: 10px;
    .form-wrap {
      margin: 0px;
      padding: 0px;
      list-style: none;
      .form-item {
        display: flex;
        margin-bottom: 0px;
        .form-label {
          flex-shrink: 0;
          display: inline-block;
          width: 100px;
          text-align: right;
          font-size: 14px;
          color: rgba(0, 0, 0, 0.65);
          &.require::before {
            content: "*";
            color: red;
          }
        }
        .form-value {
          width: 100%;
          padding-top: 2px;
          /deep/ .el-radio__input.is-checked .el-radio__inner {
            color: rgba(24, 144, 255, 1);
            border-color: rgba(24, 144, 255, 1);
            background: rgba(24, 144, 255, 1);
          }
          /deep/ .el-radio__input.is-checked + .el-radio__label {
            color: rgba(24, 144, 255, 1);
          }
          /deep/ .el-input-group__append,
          /deep/ .el-input-group__prepend {
            background-color: #fff;
            color: rgba(0, 0, 0, 0.85);
            padding: 0 10px;
          }
          .el-form-item {
            margin: 0px;
          }
          .link-wrap {
            width: 500px;
            border: 1px solid rgba(0, 0, 0, 0.15);
            margin-top: 12px;
            .link-header {
              height: 44px;
              background-color: rgba(0, 0, 0, 0.02);
              border-bottom: 1px solid rgba(0, 0, 0, 0.15);
              font-size: 14px;
              color: rgba(0, 0, 0, 0.85);
              line-height: 44px;
              padding: 0 16px;
              box-sizing: border-box;
            }
            .link-content {
              font-size: 14px;
              padding: 16px;
              box-sizing: border-box;
              line-height: 22px;
              .link-area {
                word-break: break-all;
                margin: 0px;
              }
            }
          }
        }
      }
    }
    .footer-wrap {
      display: block;
      text-align: right;
    }
  }
}
</style>